<template>
  <!-- 开票信息 -->
  <el-card shadow="never" class="create_card">
    <div slot="header" class="clearfix">
      <span class="font18">开票信息</span>
    </div>
    <div style="text-align: right">
      <!-- <el-button type="primary" style="width: 150px" v-if="!editVisible" @click="editHandle()">编辑</el-button> -->
      <!-- <el-button type="primary" style="width: 150px" v-else @click="submit()">确认并保存</el-button> -->
    </div>
    <div v-if="editVisible">
        <div class="desciconLarge"></div>
        <span class="font16">发票抬头</span>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="120px"
          style="margin-top: 20px"
          label-position="left"
        >
          <el-row type="flex" style="flex-wrap: wrap;" :gutter="30" >
            <el-col :span="12">
              <el-form-item label="发票抬头" prop="invoiceTitle">
                <el-input v-model="form.invoiceTitle" placeholder="请输入发票抬头"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="企业税号" prop="enterpriseTaxNumber">
                <el-input v-model="form.enterpriseTaxNumber" placeholder="请输入企业税号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行名称" prop="openBankName">
                <el-input v-model="form.openBankName" placeholder="请输入开户行名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行账户" prop="openBankAccount">
                <el-input v-model="form.openBankAccount" placeholder="请输入开户行账户"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册地址" prop="registeredAddress">
                <el-input v-model="form.registeredAddress" placeholder="请输入注册地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册电话" prop="registeredTelephone">
                <el-input v-model="form.registeredTelephone" placeholder="请输入注册电话"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="desciconLarge"></div>
        <span class="font16">收件信息</span>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="120px"
          style="margin-top: 20px"
          label-position="left"
        >
          <el-row type="flex" :gutter="30" style="flex-wrap: wrap;">
            <el-col :span="12">
              <el-form-item label="收件人姓名" prop="addressee">
                <el-input v-model="form.addressee" placeholder="请输入收件人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收件地址" prop="deliveryAddress">
                <el-input v-model="form.deliveryAddress" placeholder="请输入收件地址"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收件邮箱" prop="receivingContact">
                <el-input v-model="form.receivingContact" placeholder="请输入收件邮箱"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="收件联系方式" prop="receivingContactInformation">
                <el-input v-model="form.receivingContactInformation" placeholder="请输入收件联系方式"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
    </div>
    <div v-if="!editVisible">
      <div v-if="infoFlag">  
      <invoiceInfoDetail :info="form"></invoiceInfoDetail>
      </div>
      <el-empty description="请在抬头管理中设置一个默认抬头" v-else></el-empty>
    </div>
  </el-card>
</template>
<script>
import { invoiceHeadInfo,saveInvoiceHead,listInvoiceHead } from "@/api/request";
import invoiceInfoDetail from "./invoiceInfoDetail";
import { getClient } from "@/plugins/auth";
import { isMobile,validEmail } from "@/plugins/validate";
import { log } from 'mathjs';
export default {
  components: {
    invoiceInfoDetail
  },
  data() {
    var validateMobile = (rule, value, callback) => {
      if (value && !isMobile(value)) {
        return callback(new Error("请输入正确的手机号"));
      }
      callback();
    };
    var validemail = (rule, value, callback) => {
      if (value && !validEmail(value)) {
        return callback(new Error("请输入正确的邮箱"));
      }
      callback();
    };
    return {
      userInfo: JSON.parse(getClient()),
      editVisible: false,
      infoFlag: false,
      form: {
        invoiceTitle: "",
        enterpriseTaxNumber: "",
        openBankName: "",
        openBankAccount: "",
        registeredAddress: "",
        registeredTelephone: "",
        addressee: "",
        deliveryAddress: "",
        receivingContact: "",
        receivingContactInformation: ""
      },
      rules: {
        invoiceTitle: [
          { required: true, trigger: "blur", message: "请输入发票抬头" },
          { max: 50, message: "发票抬头不能超过50个字", trigger: "blur" }
        ],
        enterpriseTaxNumber: [
          { required: true, trigger: "blur", message: "请输入企业税号" },
          { max: 20, message: "企业税号不能超过20个字", trigger: "blur" }
        ],
         addressee: [
          { required: true, trigger: "blur", message: "请输入收件人姓名" },
          { max: 20, message: "收件人姓名不能超过20个字", trigger: "blur" }
        ],
         openBankName: [
          { max: 50, message: "开户行名称不能超过50个字", trigger: "blur" }
        ],
         openBankAccount: [
          { max: 20, message: "开户行账号不能超过20个字", trigger: "blur" }
        ],
        registeredAddress: [
          { max: 50, message: "注册地址不能超过50个字", trigger: "blur" }
        ],
        registeredTelephone: [
          { validator: validateMobile, trigger: "blur" }
        ],
        deliveryAddress: [
          { required: true, trigger: "blur", message: "请输入收件地址" },
          { max: 50, message: "收件地址不能超过50个字", trigger: "blur" }
        ],
        receivingContact: [
          { required: true, trigger: "blur", message: "请输入收件邮箱" },
          { validator: validemail, trigger: "blur" }
          // { max: 20, message: "收件联系人不能超过20个字", trigger: "blur" }
        ],
        receivingContactInformation: [
          { required: true, trigger: "blur", message: "请输入收件联系方式" },
          { validator: validateMobile, trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
      this.getInfo()
  },
  methods: {
    editHandle() {
      this.editVisible = true;
    },
    getInfo() {
      listInvoiceHead({clientId: this.userInfo.clientId,isDefault: 1}).then(res => {
        // console.log(res);
        if(res.rows && res.rows.length > 0){
          this.infoFlag = true
          this.form = res.rows[0]
        }else{
          this.infoFlag = false
        }
      })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          saveInvoiceHead(this.form).then(res => {
            this.$message.success("操作成功");
            this.getInfo()
            this.editVisible = false
          });
        }
      });
    }
  }
};
</script>